var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8405 18.1359C20.4441 16.1787 20.3325 13.2862 18.5056 11.4593C16.5598 9.51358 13.4051 9.51353 11.4593 11.4593C9.51353 13.4051 9.51358 16.5598 11.4593 18.5056C13.2862 20.3325 16.1787 20.4441 18.1359 18.8405L21.1494 21.8541C21.344 22.0487 21.6595 22.0486 21.8541 21.8541C22.0486 21.6595 22.0487 21.344 21.8541 21.1494L18.8405 18.1359ZM17.801 12.164C19.3576 13.7206 19.3576 16.2444 17.801 17.801C16.2444 19.3576 13.7206 19.3576 12.164 17.801C10.6073 16.2444 10.6074 13.7206 12.164 12.164C13.7206 10.6074 16.2444 10.6073 17.801 12.164Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c85e21cc13c1719a469dd091b0be14b9.svg";
export { ForwardRef as ReactComponent };